import type { GemxQlQueryResponse } from '../graphql';
import type { TableDataType } from '~/types/graphql';

export type ColumnTypesMap = Record<string, TableDataType>;

export const extractQueryRows = (response?: GemxQlQueryResponse): Record<string, unknown>[] =>
  response?.gemxQLQuery?.tableData?.rows ?? [];

export const extractQueryColumns = (response?: GemxQlQueryResponse) =>
  response?.gemxQLQuery?.tableData?.columns ?? [];

export const extractColumnTypes = (response?: GemxQlQueryResponse): ColumnTypesMap => {
  const columns = extractQueryColumns(response);
  const columnTypes: ColumnTypesMap = {};

  for (const column of columns) {
    if (column?.name) columnTypes[column.name] = column.dataType;
  }
  return columnTypes;
};
